import React from 'react';
import BackButton from '../components/BackButton';
import Manifesto from '../components/Manifesto';

function ManifestoPage() {
  return (
    <>
      <div style={{ height: '80px' }} />
      <BackButton />
      <Manifesto />
    </>
  );
}

export default ManifestoPage;
